import React from 'react';
import PropTypes from 'prop-types';
import { Stars } from '../../utils';

import {
  HotelContainer,
  HotelFooter,
  HotelHeader,
  HotelInfoContainer,
  HotelPreview,
  HotelTitle,
} from './styles';

const HotelCheckoutPreview = ({ marginBottom }) => (
  <HotelInfoContainer style={{ marginBottom }}>
    <HotelPreview />
    <HotelContainer>
      <HotelHeader>
        <p>Day Pass</p>
        <p>Los Angeles</p>
      </HotelHeader>
      <HotelTitle>The Beverly Hilton</HotelTitle>
      <HotelFooter>
        <Stars amount={5} rate={5} />
        <span>128</span>
      </HotelFooter>
    </HotelContainer>
  </HotelInfoContainer>
);

HotelCheckoutPreview.propTypes = {
  marginBottom: PropTypes.number,
};

export default HotelCheckoutPreview;
